import { NormalizedUnitNumber } from '@/domain/types/NumericValues'

/**
 * Supply validation status for Euler vaults
 */
export type EulerSupplyStatus = 'available' | 'cap-warning' | 'cap-reached' | 'paused'

/**
 * Borrow validation status for Euler vaults
 */
export type EulerBorrowStatus =
  | 'available'
  | 'cap-warning'
  | 'cap-reached'
  | 'low-liquidity'
  | 'no-liquidity'
  | 'paused'

/**
 * Validation result with status and message
 */
export interface EulerValidationResult {
  status: EulerSupplyStatus | EulerBorrowStatus
  message?: string
  severity: 'info' | 'warning' | 'error'
  canProceed: boolean
}

/**
 * Parameters for supply validation
 */
export interface EulerSupplyValidationParams {
  value?: NormalizedUnitNumber
  totalAssets: NormalizedUnitNumber
  supplyCap?: NormalizedUnitNumber
  isPaused?: boolean
}

/**
 * Parameters for borrow validation
 */
export interface EulerBorrowValidationParams {
  value?: NormalizedUnitNumber
  totalBorrowed: NormalizedUnitNumber
  borrowCap?: NormalizedUnitNumber
  availableLiquidity: NormalizedUnitNumber
  isPaused?: boolean
  symbol?: string
}

/**
 * Cap utilization thresholds
 */
export const CAP_WARNING_THRESHOLD = 0.9 // 90%
export const LIQUIDITY_WARNING_THRESHOLD = 0.1 // 10% of total assets

